import { CommerceBusinessBranchActions } from '../actions/commerce-business-branch-actions.mjs';
import { LoginActions, QuestionActions } from '@ignitesales/neuro-application';

const setSendToInsightFlagInSession = (uuid, value) => {
  window.sessionStorage.setItem(`${uuid}_sendToInsight`, JSON.stringify({
    isSubmitted: value,
  }));
};

const commerceBusinessBranchReducer = (state, action) => {
  switch (action.type) {
    case CommerceBusinessBranchActions.DEEP_LINK_CHECK_FINISHED: {
      return {
        ...state,
        commerceAppIsReady: true
      }
    }
    case CommerceBusinessBranchActions.SALESFORCE_COMPANY_SEARCH_INIT: {
      return { 
        ...state,
        salesForceSearchResults: {
          isLoading: true,
        },
      }
    }
    case CommerceBusinessBranchActions.SALESFORCE_COMPANY_SEARCH_SUCCESS: {
      return { 
        ...state,
        salesForceSearchResults: {
          companies: action.payload,
          error: undefined,
        },
      }
    }
    case CommerceBusinessBranchActions.SALESFORCE_COMPANY_SEARCH_FAILURE: {
      return { 
        ...state,
        salesForceSearchResults: {
          companies: [],
          error: 'ERROR',
        },
      }
    }
    case CommerceBusinessBranchActions.SALESFORCE_CONTACT_SEARCH_INIT: {
      return { 
        ...state,
        salesForceSearchResults: {
          ...state.salesForceSearchResults,
          isLoading: true,
        },
      }
    }
    case CommerceBusinessBranchActions.SALESFORCE_CONTACT_SEARCH_SUCCESS: {
      return { 
        ...state,
        salesForceSearchResults: {
          ...state.salesForceSearchResults,
          contacts: action.payload.contacts,
          account: action.payload.account,
          accountId: action.accountId,
          error: undefined,
          isLoading: false,
        },
      }
    }
    case CommerceBusinessBranchActions.SALESFORCE_CONTACT_SEARCH_FAILURE: {
      return { 
        ...state,
        salesForceSearchResults: {
          ...state.salesForceSearchResults,
          contacts: [],
          error: 'ERROR',
          isLoading: false,
        },
      }
    }
    case LoginActions.EMPLOYEE_LOGIN_STARTED: {
      window.localStorage.setItem('sessionStartTime', Date.now());
      return {
        ...state,
      }
    }
    case CommerceBusinessBranchActions.SALESFORCE_SUBMIT_SUCCESS: {
      setSendToInsightFlagInSession(state.user?.uuid, true);
      return {
        ...state,
      }
    }
    case QuestionActions.ANSWER_VALUE_CHANGED: {
      setSendToInsightFlagInSession(state.user?.uuid, false);
      return {
        ...state,
      }
    }
    case CommerceBusinessBranchActions.PRODUCT_SELECTED: {
      setSendToInsightFlagInSession(state.user?.uuid, false);
      return {
        ...state,
      }
    }
    case CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_LOAD_INIT: {
      return { 
        ...state,
        submittedProductsState: {
          isLoading: true,
          submittedIds: [],
        },
      }
    }
    case CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_LOAD_SUCCESS: {
      return { 
        ...state,
        submittedProductsState: {
          submittedIds: action.payload,
          isLoading: false,
        },
      }
    }
    case CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_LOAD_FAILURE: {
      return { 
        ...state,
        submittedProductsState: {
          ...state.submittedProductsState,
          isLoading: false,
        },
      }
    }
    case CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_UPDATE_INIT: {
      return { 
        ...state,
        submittedProductsState: {
          ...state.submittedProductsState,
          isLoading: true,
        },
      }
    }
    case CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_UPDATE_SUCCESS: {
      return { 
        ...state,
        submittedProductsState: {
          submittedIds: action.payload,
          isLoading: false,
        },
      }
    }
    case CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_UPDATE_FAILURE: {
      return { 
        ...state,
        submittedProductsState: {
          ...state.submittedProductsState,
          isLoading: false,
        },
      }
    }
    default:
      return state;
  }
}

export default commerceBusinessBranchReducer;
